export { default as ADLogoMobile } from './AspenDentalLogoMobile'
export { default as CCLogoMobile } from './ClearChoiceLogoMobile'
